import { Button } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { addStandardSubscriptions, adminToggleSubscriptionCompletion } from "../../actions";
import { generatePublicUrl } from "../../urlConfig";
import EmptyMessage from "./EmptyMessage";

const SubscribersContent = ({ userDetails }) => {
    const dispatch = useDispatch();
    const subscriptions = Array.isArray(userDetails?.subscriptions) ? userDetails.subscriptions : [];
    const activeCount = subscriptions.filter((item) => item?.isCompleted).length;

    const addSubUser = () => {
        dispatch(addStandardSubscriptions(userDetails._id));
    };

    const toggleSubscription = (subscriptionId) => {
        dispatch(adminToggleSubscriptionCompletion(subscriptionId, userDetails._id));
    };

    return (
        <div className="userSection">
            <div className="userSection__head">
                <div>
                    <span>Подписки</span>
                    <h3>Подписки пользователя</h3>
                    <p>Активных: {activeCount} из {subscriptions.length}.</p>
                </div>
            </div>

            {subscriptions.length ? (
                <div className="subscribersContent">
                    <div className="subscribersContent__row">
                        {subscriptions.map((item) => {
                            const picture = item?.mainPage?.itemPictures?.[0]?.img;
                            const title = item?.mainPage?.title || item?.mainPage?.name || "Без названия";
                            const date = item?.date ? String(item.date) : "";

                            return (
                                <div
                                    className={`subscribersContent__item ${item.isCompleted ? "success" : "error"}`}
                                    key={item._id}
                                >
                                    {picture ? (
                                        <div className="subscribersContent__imgBox">
                                            <img src={generatePublicUrl(picture)} alt={title} />
                                        </div>
                                    ) : null}

                                    <div className="subscribersContent__contentBox">
                                        <div className="subscribersContent__title">{title}</div>
                                        <div className="subscribersContent__date">
                                            <span>Время:</span>{" "}
                                            {date ? `${date.slice(0, 10)} ${date.slice(11, 19)}` : "—"}
                                        </div>
                                        <Button
                                            variant="contained"
                                            color={item.isCompleted ? "error" : "success"}
                                            onClick={() => toggleSubscription(item._id)}
                                        >
                                            {item.isCompleted ? "Отписать" : "Подписать"}
                                        </Button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            ) : (
                <div className="userSection__empty">
                    <EmptyMessage message="У пользователя отсутствуют подписки." />
                    <Button variant="contained" onClick={addSubUser}>
                        Создать подписки по умолчанию
                    </Button>
                </div>
            )}
        </div>
    );
};

export default SubscribersContent;
